import { Helmet } from "react-helmet-async";

const SITE = "https://moveload.co.za";

interface SeoProps {
  title: string;
  description: string;
  path: string;
  type?: "website" | "article";
  /** Absolute or root-relative image URL for social previews. */
  image?: string;
  jsonLd?: Record<string, any> | Record<string, any>[];
}

export function Seo({ title, description, path, type = "website", image, jsonLd }: SeoProps) {
  const url = `${SITE}${path}`;
  const imageUrl = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : undefined;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
}
